import useResponsive from '@/hooks/useResponsive';
import { Box, BoxProps } from '@mui/material';
import { NAV } from './constants';

const SPACING = 8;

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 62,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export default function Main({ children, sx, ...other }: BoxProps) {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Box
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        pt: 0,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
        }),
        pb: 0,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
